__turbopack_context__.v({
  "className": "ibm_plex_sans_1344998e-module__ApaLwW__className",
});
